<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch01">
<a id="page08">
<div class="chapterHead">
</div>
<div class="chapterBody">
<p class="paraNoIndent0" style="text-indent:0%;"><span class="bold">Rebecca Winters</span> is the mother of four who was very excited about the new millennium because it meant another new beginning for her. Having said goodbye to the classroom where she taught French and Spanish, she is now free to spend more time with her family, to travel and to write the Mills &amp; Boon novels she loves so dearly.</p>
<p class="paraNoIndent1" style="text-indent:0%;">Rebecca Winters has been nominated for a Reader’s Choice Award for her title <em class="italic">The Faithful Bride</em> and was previously voted Utah Writer of the Year! You can visit her Web site at www.rebeccawinters-author.com</p>
<p class="paraCenter1" style="text-indent:0%;"><span class="bold">Look out for Prince Raoul’s best friend’s story,<br/> THE BABY DILEMMA, coming next month,<br/> Harlequin Romance® #3710!</span></p>
</div>
</a></div>
<a id="page08">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781426881688_ch01.vue?56c3f1a4